module.exports = __webpack_public_path__ + "static/img/OrganizationC250107TW.fbdfdac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/OrganizationC250107TW.jpg
// module id = vdOk
// module chunks = 1